// extracted by mini-css-extract-plugin
export default {"espacamento":"Combo_espacamento__mVdD9","label":"Combo_label__bw4iJ"};